<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    @close="loseDialog"
    :close-on-click-modal="false"
  >
    <el-form
      ref="curdForm"
      :size="size"
      :rules="rules"
      :model="curdForm"
      label-position="right"
      label-width="100px"
    >
      <el-row>
        <el-col>
          <el-form-item label="所属学院：">
            <span>{{deptName}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <!-- :span="12" -->
        <el-col>
          <el-form-item label="类型：">
            <el-radio-group v-model="stepIdx">
              <el-radio
                size="medium"
                :label="i"
                v-for="(item, i) in stepList"
                :key="i"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="userType == -1 && stepIdx == 0">
          <el-form-item
            label="角色类型："
            prop="roleType"
            :rules="[
              { required: true, message: '请选择角色类型', trigger: 'blur' }
            ]"
          >
            <el-select
              v-model="curdForm.roleType"
              placeholder="请选择角色类型"
              style="width: 100%"
            >
              <el-option
                v-for="(item, i) in roleTypeAttr"
                :key="i"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="stepIdx == 0">
          <el-form-item label="角色名称：" prop="roleName">
            <el-input
              v-model="curdForm.roleName"
              placeholder="请填写角色名称"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="stepIdx == 0">
          <el-form-item label="角色描述：" prop="roleDesc">
            <el-input
              type="textarea"
              v-model="curdForm.roleDesc"
              placeholder="请填写角色描述"
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col v-show="stepIdx == 1">
          <el-form-item prop="menus">
            <el-input
              placeholder="输入关键字进行过滤"
              v-model="filterText"
              style="margin-bottom: 8px; width: 76%"
            >
            </el-input>
            <butn
              v-if="showSetAll"
              style="margin-left: 6px"
              title="全选"
              @click.native="setAllChecked"
            ></butn>
            <butn
              v-else
              style="margin-left: 6px"
              title="清空"
              @click.native="clearAllChecked"
            ></butn>
            <el-tree
              class="common-tree"
              ref="roleTree"
              :data="menuTreeList"
              :props="props"
              show-checkbox
              node-key="uuid"
              :check-strictly="false"
              :filter-node-method="filterNode"
              @check-change="handleCheckChange"
            ></el-tree>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn title="取消" @click.native="closeFrom('curdForm')"></butn>
      <butn btntype="primary" title="确定" @click.native="createData"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
// import treeSelet from "@/components/treeSelet/index";
import Bus from "./Bus.js";
import rulesFactory from "@/utils/rules";
import { menuListAll } from "@/api/menu";
import { roleSave, roleUpdate, getRoleMenu } from "@/api/role";
import { getItem } from "@/utils/storage";
import { getDataMap } from "@/api/sysParam";

export default {
  components: { butn },
  data() {
    return {
      Bus,
      userType: getItem("userType"),
      stepIdx: 0,
      stepList: ["角色信息", "角色权限配置"],
      filterText: "",
      size: "small",
      curdTitle: "",
      CUFlag: false,
      Dflag: false,
      curdForm: {},
      rules: {
        roleName: [
          rulesFactory.required("角色名称不能为空"),
          rulesFactory.size("最多输入20个字", 0, 20)
        ]
      },
      props: {
        //树形
        label: "menuName",
        children: "children"
      },
      menuTreeList: [],
      menuUuids: [],
      roleMenuKey: [],
      roleTypeAttr: [],
      showSetAll: true,
      command: function() {},
      deptName: "",
    };
  },
  watch: {
    filterText(val) {
      this.$refs.roleTree.filter(val);
    }
  },
  created() {
    var _this = this;
    if (_this.userType == -1) {
      _this.getSysParam("ROLE_TYPE");
    }
    Bus.$on("handleUpdate", function(item) {
      _this.curdTitle = item == "" ? "新增角色" : "编辑角色";
      _this.command = item == "" ? roleSave : roleUpdate;
      if (item !== "") {
        _this.deptName = item.deptName;
        _this.getRoleMenu(item.uuid);
      } else {
        _this.deptName = getItem("topDeptName");
      }
      _this.CUFlag = true;
      _this.curdForm = item == "" ? { roleType: 1 } : item;
    });
  },
  methods: {
    initMenuL() {
      menuListAll().then(data => {
        this.menuTreeList = data.data;
      });
    },
    // 获取数据字典：用户类型
    getSysParam(param) {
      getDataMap(param).then(res => {
        if (!res || res.code != 0) return;
        this.roleTypeAttr = res.data;
      });
    },
    getRoleMenu(uuid) {
      const _this = this;
      getRoleMenu(uuid).then(res => {
        if (!res || res.code != 0) return;
        res.data.forEach(value => {
          _this.$refs.roleTree.setChecked(value, true, false);
        });
      });
    },
    // 过滤菜单
    filterNode(value, data) {
      if (!value) return true;
      return data.menuName.indexOf(value) !== -1;
    },
    // 全选
    setAllChecked() {
      this.showSetAll = false;
      this.$refs.roleTree.setCheckedNodes(this.menuTreeList);
    },
    // 清空
    clearAllChecked() {
      this.showSetAll = true;
      this.$refs.roleTree.setCheckedKeys([]);
    },
    handleCheckChange() {
      //获取所有被选中的key的数组
      let halfCheckKeys = this.$refs.roleTree.getHalfCheckedKeys();
      let leafCheckKeys = this.$refs.roleTree.getCheckedKeys();
      this.menuUuids = leafCheckKeys.concat(halfCheckKeys);
    },
    createData() {
      this.$refs.curdForm.validate(valid => {
        if (valid) {
          this.loading = true;
          const params = Object.assign({}, this.curdForm);
          params.menuUuids = this.menuUuids;
          this.command(params)
            .then(res => {
              if (!res || res.code != 0) throw new Error(res.msg);
              this.$message.success(res.msg);
              this.$emit("search", "");
              this.CUFlag = false;
            })
            .finally(() => (this.loading = false));
        }
      });
    },
    closeFrom(curdForm) {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.stepIdx = 0;
      this.roleMenuList = [];
      this.$refs.roleTree.setCheckedKeys([]);
      this.$refs[curdForm].resetFields();
    },
    loseDialog() {
      // 点击取消 数据重置
      this.CUFlag = false;
      this.stepIdx = 0;
      this.roleMenuList = [];
      this.$refs.roleTree.setCheckedKeys([]);
      this.$refs["curdForm"].resetFields();
    }
  },
  mounted() {
    this.initMenuL();
  },
  beforeDestroy() {
    Bus.$off("handleUpdate");
  }
};
</script>
